import { partnerCockpitBannersSchema, type PartnerCockpitBanner } from '@houzy/schemas/partner-cockpit/announcements';
import { queryOptions, useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';

import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';

export type { PartnerCockpitBanner };

export const bannersQueryKey = ['banners'] as const;

const BANNERS_STALE_TIME_MS = 30_000; // 30 seconds

export const bannersQueryOptions = queryOptions({
    queryKey: [...bannersQueryKey, 'list'],
    queryFn: ({ signal }) =>
        apiRequest(partnerCockpitApiPath('banners'), { signal, responseSchema: partnerCockpitBannersSchema }),
    staleTime: BANNERS_STALE_TIME_MS,
});

export function useBanners(enabled = true): UseQueryResult<PartnerCockpitBanner[]> {
    return useQuery({ ...bannersQueryOptions, enabled });
}

export const offerRequestDetailBannersQueryOptions = queryOptions({
    queryKey: [...bannersQueryKey, 'list', 'OfferRequestDetail'],
    queryFn: ({ signal }) =>
        apiRequest(partnerCockpitApiPath('banners?placement=OfferRequestDetail'), {
            signal,
            responseSchema: partnerCockpitBannersSchema,
        }),
    staleTime: BANNERS_STALE_TIME_MS,
});

export function useOfferRequestDetailBanners(): UseQueryResult<PartnerCockpitBanner[]> {
    return useQuery(offerRequestDetailBannersQueryOptions);
}

export function useDismissBanner(): ReturnType<typeof useMutation<void, Error, string>> {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [...bannersQueryKey, 'dismiss'],
        mutationFn: (bannerUuid: string): Promise<void> =>
            apiRequest(partnerCockpitApiPath(`banners/${bannerUuid}/dismiss`), { method: 'POST' }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: bannersQueryKey }).catch(() => undefined);
        },
    });
}
